export default __webpack_public_path__ + "static/media/estrategia-matematica-natureza.ea99a934.jpg";